<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="用户">
								<a-input v-model="queryParams.user" placeholder="ID/昵称" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="性别">
								<a-select v-model="queryParams.sex" placeholder="请选择" default-value="">
									<a-select-option value="MALE">男</a-select-option>
									<a-select-option value="FEMALE">女</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<!-- <a-col :span="4">
							<a-form-item label="马甲">
								<a-select v-model="queryParams.isUser" placeholder="请选择" default-value="">
									<a-select-option value="Y">是</a-select-option>
									<a-select-option value="N">否</a-select-option>
								</a-select>
							</a-form-item>
						</a-col> -->
						<template v-if="advanced">
							<a-col :md="8">
								<a-form-item label="注册时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
							<a-col :md="8">
								<a-form-item label="活跃时间">
									<a-range-picker @change="onActiveTime" v-model="activeTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<div class="x-tool">
				<a-button type="primary" icon="plus" v-has="'/member/user/userAdd'" @click="add">新增</a-button>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">
				<template slot="user" slot-scope="record">
					<div class="user">
						<div class="user-left">
							<img class="cover-img" :src="record.avatarUrl" width="48px" height="48px" @click="openDetail(record.id)" />
							<span style="color:#acacac">{{record.account}}</span>
						</div>
						<div class="user-right">
							<p class="first">
								<!-- <span v-if="record.isVest=='Y'">【马甲】</span> -->
								<span class="nickname">{{ record.nickname }}</span>
								<span v-if="record.status=='DISABLE'" class="error">【已禁用】</span>
								<span v-else-if="record.status=='DEACTIVATE'" class="error">【已注销】</span>
							</p>
							<p class="row">
								<span class="user-right-detail" v-if="record.sex=='MALE'">男</span>
								<span class="user-right-detail" v-else>女</span>
								<span class="user-right-detail">{{ record.age }}岁</span>
								<span class="user-right-detail">{{ record.province }}{{ record.city }}</span>
								<span class="user-right-detail">{{ dictTrans('maritalStates', record.maritalStatus) || '-' }}</span>
							</p>
							<p class="row" v-if="record.isVip=='Y'">
								<span style="font-weight: bold; color:red">VIP</span>
							</p>
						</div>
					</div>
				</template>
				<template slot="isOnline" slot-scope="record">
					<div class="complex">
						<span class="online-status" :class="{'online': record.isOnline=='Y', 'offline': record.isOnline=='N'}">{{ record.isOnline=='Y' ? '在线' : '离线' }}</span>
					</div>
				</template>

				<template slot="account" slot-scope="record">
					<div class="complex">
						<span>金币：{{record.gold}}</span>
						<span>积分：{{record.score}}</span>
					</div>
				</template>
				<template slot="recharge_withdrawal" slot-scope="record">
					<div class="complex">
						<span>充值：{{record.rechargeAmount}}元 / <span style="color:#acacac;">{{ record.rechargeNum }}次</span></span>
						<span>提现：{{record.cashoutAmount}}元 / <span style="color:#acacac;">{{ record.cashoutNum }}次</span></span>
					</div>
				</template>
				<template slot="call" slot-scope="record">
					<div class="complex">
						<span>时长：{{ record.totalCallLen != null ? record.totalCallLen : 0 }}分钟</span>
						<span>次数：{{ record.totalCallNum != null ? record.totalCallNum : 0 }}次</span>
					</div>
				</template>
				<template slot="charm" slot-scope="record">
					<div class="complex">
						<span>{{ record.charm }} / <span style="color:#acacac;">{{ record.weighting }}</span></span>
					</div>
				</template>
				<template slot="source" slot-scope="record">
					<div class="complex">
						<span>推广:{{ record.inviteCount != null ? record.inviteCount : 0 }}人</span>
						<span>邀请人:{{ record.parentUserNickname || '-' }}</span>
					</div>
				</template>

				<template slot="date" slot-scope="record">
					<div class="complex">
						<span>活跃：{{ record.activeTime ? record.activeTime : '-' }}</span>
						<span style="color: #acacac;">注册：{{ record.created }}</span>
					</div>
				</template>
				<template slot="action" slot-scope="record">
					<a @click="openDetail(record.id)">详情</a>
					<a-divider type="vertical" />
					<a-dropdown>
						<a class="ant-dropdown-link" @click="e => e.preventDefault()">
							更多 <a-icon type="down" />
						</a>
						<a-menu slot="overlay">
							<a-menu-item><a v-has="'/member/user/userUpdate'" @click="update(record)">修改</a></a-menu-item>
							<a-menu-item><a v-has="'/content/momentAdd'"
									@click="addMoment(record.id)">添加日常</a></a-menu-item>
							<a-menu-item v-if="record.status == 'DISABLE'"><a v-has="'/member/user/user_update_status'"
									@click="startstop(record.id, 'NORMAL')">启用</a></a-menu-item>
							<a-menu-item v-else class="error"><a v-has="'/member/user/user_update_status'"
									@click="startstop(record.id, 'DISABLE')">禁用</a></a-menu-item>
							<a-menu-item v-if="record.isVest == 'N'"><a @click="openWeightModal(record)">加权</a></a-menu-item>
							<a-menu-item><a v-has="'/member/user/userAdjustGold'" @click="openGoldModal(record)">上分</a></a-menu-item>
						</a-menu>
					</a-dropdown>
				</template>
			</a-table>

			<User-form-modal ref="UserForm" :visible="UserFormVisible" :loading="UserFormLoading" :model="UserFormModel"
				@cancel="UserFormCancel" @ok="UserFormOk" />

			<a-modal
				title="加权"
				:visible="weightModalVisible"
				:maskClosable="false"
				@ok="weightModalOk"
				@cancel="weightModalCancel"
			>
				<a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
					<a-form-item label="当前权重">
						<span>{{ weightCurrent }}</span>
					</a-form-item>
					<a-form-item label="操作类型">
						<a-radio-group v-model="weightChangeType">
							<a-radio value="add">增加</a-radio>
							<a-radio value="reduce">减少</a-radio>
						</a-radio-group>
					</a-form-item>
					<a-form-item
						label="权重数量"
						:validate-status="weightError ? 'error' : ''"
						:help="weightError || weightPreviewHelp"
					>
						<a-input-number
							v-model="weightInput"
							:min="1"
							:precision="0"
							placeholder="请输入权重数量"
							style="width: 100%"
						/>
					</a-form-item>
				</a-form>
			</a-modal>

			<a-modal
				title="禁用用户"
				:visible="disableModalVisible"
				:maskClosable="false"
				:confirmLoading="disableModalLoading"
				width="560px"
				@ok="disableModalOk"
				@cancel="disableModalCancel"
			>
				<a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
					<a-form-item
						class="disable-duration-item"
						label="禁用时间"
						required
						:validate-status="disableDurationError ? 'error' : ''"
						:help="disableDurationError"
					>
						<a-radio-group v-model="disableDuration" class="disable-duration-group">
							<a-radio :value="1">1天</a-radio>
							<a-radio :value="3">3天</a-radio>
							<a-radio :value="7">7天</a-radio>
							<a-radio :value="30">30天</a-radio>
							<a-radio :value="365">永久封禁</a-radio>
						</a-radio-group>
					</a-form-item>
					<a-form-item
						label="禁用原因"
						required
						:validate-status="disableReasonError ? 'error' : ''"
						:help="disableReasonError || `${(disableReason || '').length}/100`"
					>
						<a-textarea
							v-model="disableReason"
							:rows="4"
							:maxLength="100"
							placeholder="请输入禁用原因"
						/>
					</a-form-item>
				</a-form>
			</a-modal>

			<a-modal
				title="上分"
				:visible="goldModalVisible"
				:maskClosable="false"
				:confirmLoading="goldModalLoading"
				@ok="goldModalOk"
				@cancel="goldModalCancel"
			>
				<a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
					<a-form-item label="当前金币">
						<span>{{ goldCurrent }}</span>
					</a-form-item>
					<a-form-item label="操作类型">
						<a-radio-group v-model="goldChangeType">
							<a-radio value="add">增加</a-radio>
							<a-radio value="reduce">减少</a-radio>
						</a-radio-group>
					</a-form-item>
					<a-form-item
						label="金币数量"
						:validate-status="goldError ? 'error' : ''"
						:help="goldError || goldPreviewHelp"
					>
						<a-input-number
							v-model="goldInput"
							:min="1"
							:precision="0"
							placeholder="请输入金币数量"
							style="width: 100%"
						/>
					</a-form-item>
				</a-form>
			</a-modal>

			<MomentForm
				ref="momentForm"
				:visible="momentVisible"
				:user-id="userId"
				@ok="momentFormOk"
				@cancel="momentFormCancel"
			/>

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>

		<user-detail-drawer ref="userDetailDrawer" />
	</div>
</template>

<script>
	import moment from "moment";
	import UserFormModal from "@/pages/member/user/UserForm.vue";
	import MomentForm from "@/pages/content/moment/MomentForm.vue";
	import UserDetailDrawer from "@/components/UserDetailDrawer.vue";
	import { userList, userAdd, userUpdate, userAddWeight, userAdjustGold, userUpdateStatus } from "@/api/member/user";
	import {
		momentAdd
	} from "@/api/content/moment";
	import { dictTrans } from '@/utils/dictTrans.js';

	const tableColumns = [{
			title: '#',
			dataIndex: 'id'
		},
		{
			title: '用户',
			scopedSlots: {
				customRender: 'user'
			}
		},
		{
			title: '在线状态',
			scopedSlots: {
				customRender: 'isOnline'
			}
		},
		{
			title: '账户',
			scopedSlots: {
				customRender: 'account'
			}
		},
		{
			title: '充提',
			scopedSlots: {
				customRender: 'recharge_withdrawal'
			}
		},
		{
			title: '通话',
			scopedSlots: {
				customRender: 'call'
			}
		},
		{
			title: '魅力',
			scopedSlots: {
				customRender: 'charm'
			}
		},
		{
			title: '邀请',
			scopedSlots: {
				customRender: 'source'
			}
		},
		{
			title: '时间',
			scopedSlots: {
				customRender: 'date'
			}
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			UserFormModal,
			MomentForm,
			UserDetailDrawer,
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				UserFormVisible: false,
				UserFormLoading: false,
				UserFormModel: null,
				activeTime: [],
				createTime: [],
				fileList: [],
				userId: 0,
				momentVisible: false,
				weightModalVisible: false,
				weightUserId: null,
				weightCurrent: 0,
				weightChangeType: 'add',
				weightInput: undefined,
				weightError: '',
				goldModalVisible: false,
				goldModalLoading: false,
				goldUserId: null,
				goldCurrent: 0,
				goldChangeType: 'add',
				goldInput: undefined,
				goldError: '',
				disableModalVisible: false,
				disableModalLoading: false,
				disableUserId: null,
				disableDuration: undefined,
				disableReason: '',
				disableDurationError: '',
				disableReasonError: '',
			}
		},
		computed: {
			weightPreviewHelp() {
				const current = Number(this.weightCurrent) || 0;
				const delta = Number(this.weightInput);
				if (!delta || delta <= 0) {
					return '';
				}
				const after = this.weightChangeType === 'add'
					? current + delta
					: current - delta;
				if (after < 0) {
					return '调整后权重不能小于 0';
				}
				return `调整后权重：${after}`;
			},
			goldPreviewHelp() {
				const current = Number(this.goldCurrent) || 0;
				const delta = Number(this.goldInput);
				if (!delta || delta <= 0) {
					return '';
				}
				const after = this.goldChangeType === 'add'
					? current + delta
					: current - delta;
				if (after < 0) {
					return '调整后余额不能小于 0';
				}
				return `调整后余额：${after}`;
			},
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			dictTrans,
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				userList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;

					this.tableLoading = false;
				});
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			onActiveTime(values) {
				this.queryParams.startActiveTime = moment(values[0]).unix();
				this.queryParams.endActiveTime = moment(values[1]).unix();
			},
			add() {
				this.UserFormModel = null;
				this.UserFormVisible = true;
				this.$nextTick(() => {
					if (this.$refs.UserForm && this.$refs.UserForm.initForm) {
						this.$refs.UserForm.initForm();
					}
				});
			},
			update(record) {
				this.UserFormModel = {
					...record
				};
				this.UserFormVisible = true;
			},
			openDetail(id) {
				if (this.$refs.userDetailDrawer) {
					this.$refs.userDetailDrawer.open(id);
				}
			},
			UserFormOk() {
				const userFormRef = this.$refs.UserForm;
				if (!userFormRef || !userFormRef.$refs.adminForm) {
					return;
				}
				userFormRef.$refs.adminForm.validate(valid => {
					if (!valid) {
						return;
					}
					const values = { ...userFormRef.userForm };
					this.UserFormLoading = true;
					if (values.id > 0) {
						userUpdate(values).then(() => {
							this.UserFormAfter('修改用户成功');
						}).catch(() => {
							this.UserFormLoading = false;
						});
					} else {
						userAdd(values).then(() => {
							this.UserFormAfter('新增用户成功');
						}).catch(() => {
							this.UserFormLoading = false;
						});
					}
				});
			},
			UserFormCancel() {
				this.UserFormModel = null;
				this.UserFormVisible = false;
				if (this.$refs.UserForm && this.$refs.UserForm.initForm) {
					this.$refs.UserForm.initForm();
				}
			},
			UserFormAfter(message) {
				this.UserFormVisible = false;
				this.UserFormLoading = false;
				if (this.$refs.UserForm && this.$refs.UserForm.initForm) {
					this.$refs.UserForm.initForm();
				}
				this.fetchTableData();
				this.$message.success(message);
			},
			rest() {
				this.activeTime = [];
				this.createTime = [];
				this.queryParams = {}
			},
			addMoment(userId) {
				this.userId = userId;
				this.momentVisible = true;
			},
			momentFormOk(values) {
				momentAdd(values).then((res) => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '提交失败');
						return;
					}
					if (this.$refs.momentForm && this.$refs.momentForm.clearAfterSubmit) {
						this.$refs.momentForm.clearAfterSubmit();
					}
					this.momentVisible = false;
					this.userId = 0;
					this.fetchTableData();
					this.$message.success('操作成功');
				}).catch(() => {
					this.$message.error('提交失败');
				});
			},
			momentFormCancel() {
				this.momentVisible = false;
				this.userId = 0;
				if (this.$refs.momentForm && this.$refs.momentForm.clearAndClose) {
					this.$refs.momentForm.clearAndClose();
				}
			},
			openWeightModal(record) {
				this.weightUserId = record.id;
				this.weightCurrent = record.weighting != null ? record.weighting : 0;
				this.weightChangeType = 'add';
				this.weightInput = undefined;
				this.weightError = '';
				this.weightModalVisible = true;
			},
			weightModalOk() {
				const weight = Number(this.weightInput);
				if (!weight || weight <= 0 || !Number.isInteger(weight)) {
					this.weightError = '请输入大于 0 的整数权重数量';
					return;
				}
				const current = Number(this.weightCurrent) || 0;
				const after = this.weightChangeType === 'add' ? current + weight : current - weight;
				if (after < 0) {
					this.weightError = '减少后权重不能小于 0';
					return;
				}
				this.weightError = '';
				userAddWeight({
					id: this.weightUserId,
					changeType: this.weightChangeType,
					weight
				}).then((res) => {
					if (res.code != 200) {
						this.$message.error(res.message || '操作失败');
						return;
					}
					this.weightModalVisible = false;
					this.resetWeightModal();
					this.fetchTableData();
					this.$message.success('操作成功');
				}).catch((err) => {
					this.$message.error((err.response && err.response.data && err.response.data.message) || '操作失败');
				});
			},
			weightModalCancel() {
				this.weightModalVisible = false;
				this.resetWeightModal();
			},
			resetWeightModal() {
				this.weightUserId = null;
				this.weightCurrent = 0;
				this.weightChangeType = 'add';
				this.weightInput = undefined;
				this.weightError = '';
			},
			openGoldModal(record) {
				this.goldUserId = record.id;
				this.goldCurrent = record.gold != null ? record.gold : 0;
				this.goldChangeType = 'add';
				this.goldInput = undefined;
				this.goldError = '';
				this.goldModalVisible = true;
			},
			goldModalOk() {
				const gold = Number(this.goldInput);
				if (!gold || gold <= 0 || !Number.isInteger(gold)) {
					this.goldError = '请输入大于 0 的整数金币数量';
					return;
				}
				const current = Number(this.goldCurrent) || 0;
				const after = this.goldChangeType === 'add' ? current + gold : current - gold;
				if (after < 0) {
					this.goldError = '减少后金币余额不能小于 0';
					return;
				}
				this.goldError = '';
				this.goldModalLoading = true;
				userAdjustGold({
					id: this.goldUserId,
					changeType: this.goldChangeType,
					gold
				}).then((res) => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '操作失败');
						return;
					}
					this.goldModalVisible = false;
					this.resetGoldModal();
					this.fetchTableData();
					this.$message.success('操作成功');
				}).catch((err) => {
					this.$message.error((err.response && err.response.data && err.response.data.message) || '操作失败');
				}).finally(() => {
					this.goldModalLoading = false;
				});
			},
			goldModalCancel() {
				this.goldModalVisible = false;
				this.resetGoldModal();
			},
			resetGoldModal() {
				this.goldUserId = null;
				this.goldCurrent = 0;
				this.goldChangeType = 'add';
				this.goldInput = undefined;
				this.goldError = '';
			},
			startstop(id, status) {
				if (status === 'DISABLE') {
					this.openDisableModal(id);
					return;
				}
				userUpdateStatus(id, status).then((res) => {
					if (res.code != 200) {
						this.$message.error(res.message || '操作失败');
						return;
					}

					this.fetchTableData();
					this.$message.success('操作成功');
				}).catch((err) => {
					this.$message.error((err.response && err.response.data && err.response.data.message) || '操作失败');
				});
			},
			openDisableModal(id) {
				this.disableUserId = id;
				this.disableDuration = undefined;
				this.disableReason = '';
				this.disableDurationError = '';
				this.disableReasonError = '';
				this.disableModalVisible = true;
			},
			disableModalOk() {
				const allowDurations = [1, 3, 7, 30, 365];
				const duration = Number(this.disableDuration);
				if (this.disableDuration === undefined || this.disableDuration === null || !allowDurations.includes(duration)) {
					this.disableDurationError = '请选择禁用时间';
					return;
				}
				this.disableDurationError = '';
				const reason = (this.disableReason || '').trim();
				if (!reason) {
					this.disableReasonError = '请输入禁用原因';
					return;
				}
				if (reason.length > 100) {
					this.disableReasonError = '禁用原因不能超过100个字';
					return;
				}
				this.disableReasonError = '';
				this.disableModalLoading = true;
				userUpdateStatus(this.disableUserId, 'DISABLE', {
					duration,
					reason
				}).then((res) => {
					if (res.code != 200) {
						this.$message.error(res.message || '操作失败');
						return;
					}
					this.disableModalVisible = false;
					this.resetDisableModal();
					this.fetchTableData();
					this.$message.success('操作成功');
				}).catch((err) => {
					this.$message.error((err.response && err.response.data && err.response.data.message) || '操作失败');
				}).finally(() => {
					this.disableModalLoading = false;
				});
			},
			disableModalCancel() {
				this.disableModalVisible = false;
				this.resetDisableModal();
			},
			resetDisableModal() {
				this.disableUserId = null;
				this.disableDuration = undefined;
				this.disableReason = '';
				this.disableDurationError = '';
				this.disableReasonError = '';
			}
		}
	}
</script>

<style lang="less" scoped>
	.depict {
		width: 540px;
		margin-top: 5px;
		line-height: 150%;
		font-size: 12px;
		color: #acacac;
	}

	.user {
		display: flex;
		flex-direction: row;

		.user-left {
			display: flex;
			flex-direction: column;
			margin-right: 5px;
			text-align: center;

			.cover-img {
				cursor: pointer;
			}

			span {
				font-size: 12px;
			}
		}

		.user-right {
			p.first {
				display: flex;
				flex-direction: row;
				margin: 0;

				.nickname {
					color: #686868;
					font-weight: bold;
				}
			}

			p.row {
				font-size: 12px;
				color: #acacac;
				margin: 0;
			}

							.user-right-detail {
				margin-right: 5px;
			}
		}
	}

	.complex {
		display: flex;
		flex-direction: column;

		.online-status {
			&.online {
				color: #52c41a;
			}

			&.offline {
				color: #8c8c8c;
			}
		}
	}

	.clearfix {
		width: 100%;
	}

	/* 上传按钮样式 */
	.ant-upload-select {
		display: block;
		margin-bottom: 8px;
	}

	/* 视频预览模态框样式 */
	.ant-modal-body {
		padding: 0;
	}

	.upload-hint {
		color: rgba(0, 0, 0, 0.45);
		font-size: 12px;
		margin-top: 8px;
	}

	.disable-duration-item {
		/deep/ .ant-form-item-label,
		/deep/ .ant-form-item-control {
			line-height: 32px;
		}

		/deep/ .ant-form-item-label > label {
			line-height: 32px;
		}
	}

	.disable-duration-group {
		display: inline-flex;
		flex-wrap: wrap;
		align-items: center;
		line-height: 32px;

		/deep/ .ant-radio-wrapper {
			line-height: 32px;
			margin-right: 12px;
		}
	}
</style>